// extracted by mini-css-extract-plugin
export default {"card":"j9-z"};